export const OnBoardingJourneyRoutes = [
    {
        "url": "/obj-candidate-touchpoints/brand/:brand_id",
        "name": "appLayout.harriSH.obj-candidate-events",
        "type": "frontend",
        "showGlobalSearch": false,
        "loginRequired": true,
        "params": {},
        "component": "objCandidateEventsContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["on_boarding_journey"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/on-boarding-journey/on-boarding-journey.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/on-boarding-journey/on-boarding-journey-templates.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/brand/:brand_id/oj-toucpoint-details/:event_id?is_templates=",
        "name": "appLayout.harriSH.edit-event",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": "objEventsManagement",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["on_boarding_journey", "harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/on-boarding-journey/on-boarding-journey.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/on-boarding-journey/on-boarding-journey-templates.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/brand/:brand_id/create-oj-touchpoint?is_templates=",
        "name": "appLayout.harriSH.create-event",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": "objEventsManagement",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["on_boarding_journey", "harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/on-boarding-journey/on-boarding-journey.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/on-boarding-journey/on-boarding-journey-templates.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/:view?tab",
        "name": "appLayout.harriSH.settings.brandSection",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["on_boarding_journey", "harri-engage", "dashboards"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/on-boarding-journey/on-boarding-journey.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/on-boarding-journey/on-boarding-journey-templates.downgrade.module");
                }
            }
        ]
    },
];
//# sourceMappingURL=on-boarding-journey.routes.js.map